<template>
    <button
        v-tippy="t('editorToggleHeader3')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 3 }),
                editor.isActive('heading', { level: 3 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 3 })"
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
    >
        <MdiFormatHeader3 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader3 from 'materialdesignicons-vue3/icons/MdiFormatHeader3.js';

    defineExpose({
        name: 'FormatHeader3Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
